import { AxiosRequestConfig } from "axios"
import { UPLOAD_TIMEOUT } from "configs/AppConfig"

import { UploadResponse } from "@shared/zod/schemas/responses/upload"

import { axiosAuth, axiosPatient, axiosPublic } from "./generic/AxiosInterceptor/AxiosInterceptor"
import { generateFormData } from "./generic/HttpUtils"

const config = (url: string, files: File[]): AxiosRequestConfig => ({
  url,
  method: "post",
  headers: {
    "Content-Type": "multipart/form-data",
  },
  data: generateFormData({}, files),
  timeout: UPLOAD_TIMEOUT,
})

export const asPatient = async (files: File[]): Promise<UploadResponse[]> => {
  const resp = await axiosPatient(config("/patient/upload", files))

  return resp.data
}

export const asUser = async (files: File[]): Promise<UploadResponse[]> => {
  const resp = await axiosAuth(config("/upload", files))
  return resp.data
}

export const asPublic = async (files: File[]): Promise<UploadResponse[]> => {
  const resp = await axiosPublic(config("/public/upload", files))
  return resp.data
}
